import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";

import { getColorByEnv } from "utils/get-colors-by-env";
import { getUserName } from "utils/get-user-info";

const HeaderHome = () => {
  const userName = getUserName();

  return (
    <Container
      maxWidth={false}
      style={{ backgroundColor: getColorByEnv(), paddingBottom: "4.5rem" }}
    >
      <Typography variant="h2" component="h6" color="secondary">
        Olá, {userName}!
      </Typography>
    </Container>
  );
};

export default HeaderHome;
